import PropTypes from 'prop-types';

const componentDetail = {
  label: 'Information Card - Standard',
  value: 'InformationCard',
};
const builderConfig = {
  general: {
    title: {
      type: 'string',
      required: true,
      max: { max: 40, message: `Max length is 40` },
    },
    description: {
      type: 'long',
      required: true,
      max: { max: 120, message: `Max length is 120` },
    },
  },
};

const propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

const defaultProps = {
  title: 'Title',
  description: 'Description',
};

export default { componentDetail, builderConfig, propTypes, defaultProps };
